import React from 'react'
import Layout from '../components/common/layout'
import TermsCondsComp from '../components/terms-conditions'
import SEO from '../components/common/seo'

const TermsCondsPage = () => (
  <Layout>
    <SEO title="San Diego Refrigeration &amp; A/C Repair" />
    <TermsCondsComp />
  </Layout>
)

export default TermsCondsPage
